import styled from 'styled-components'
import { Swiper } from 'swiper/react'

export const Container = styled.div`
  margin: 0%;
  margin-top: 2rem;
  margin-bottom: 2rem;
  line-height: 0;

  @media screen and (min-width: 768px) {
    margin-top: 3rem;
    margin-bottom: 3rem;
    &:hover {
      position: relative;
      z-index: 2;
    }
  }
`

export const HeadingsContainer = styled.div`
  max-width: var(--container-max-width);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 1.5rem;
  margin: 0 auto 2rem auto;

  @media screen and (min-width: 768px) {
    margin-bottom: 3rem;
    padding: 0 1.5rem;
  }
`

export const Title = styled.h2`
  font-size: 2.4rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 400;
  font-family: ${({ theme }) => theme.fonts.serif.fontFamily};
  letter-spacing: -0.2rem;

  @media screen and (min-width: 768px) {
    font-size: 3rem;
  }
`

export const StyledSwiper = styled(Swiper)`
  padding-left: 1.5rem;
  max-width: var(--container-max-width);

  ${Container}.sm & {
    padding-left: 2.6rem;

    @media screen and (min-width: 768px) {
      padding-left: 1.6rem;
    }
  }

  .swiper-slide {
    display: flex;
    justify-content: center;

    &:last-child {
      margin-right: 2rem;
    }

    &:hover {
      @media screen and (min-width: 768px) {
        position: relative;
        z-index: 1;
      }
    }
  }
`

const ArrowContainer = styled.div`
  user-select: none;
  position: absolute;
  top: 35%;
  transform: translate(0, -50%);
  z-index: 20000;
`

export const LeftArrowContainer = styled(ArrowContainer)`
  left: 0;
`

export const RightArrowContainer = styled(ArrowContainer)`
  right: 0;
`
